module.exports = __webpack_public_path__ + "img/magnifier.2b656bdc.svg";